__turbopack_context__.v({
  "landmarkBadge": "page-module___8aEwW__landmarkBadge",
  "landmarkCard": "page-module___8aEwW__landmarkCard",
  "landmarkDesc": "page-module___8aEwW__landmarkDesc",
  "landmarkError": "page-module___8aEwW__landmarkError",
  "landmarkForm": "page-module___8aEwW__landmarkForm",
  "landmarkHint": "page-module___8aEwW__landmarkHint",
  "landmarkInput": "page-module___8aEwW__landmarkInput",
  "landmarkLabel": "page-module___8aEwW__landmarkLabel",
  "landmarkPage": "page-module___8aEwW__landmarkPage",
  "landmarkSubmit": "page-module___8aEwW__landmarkSubmit",
  "landmarkTitle": "page-module___8aEwW__landmarkTitle",
});
